var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUpGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1233 12.815L14.1808 9.87249L12.3842 8.06666C11.6233 7.30582 10.3858 7.30582 9.62499 8.06666L4.87666 12.815C4.25333 13.4383 4.70249 14.5017 5.57333 14.5017H10.7158H16.4267C17.3067 14.5017 17.7467 13.4383 17.1233 12.815Z",
    fill: "#6CC91A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpGreen);
export default __webpack_public_path__ + "static/media/arrow-up-green.d8e3d0c1110d6980aad0fd7c227e7e52.svg";
export { ForwardRef as ReactComponent };